// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__8JKBu","info":"Note_info__2dhD1","note":"Note_note__3jrzw","actions":"Note_actions__1wvyN"};